import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoft = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23 23",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#f3f3f3",
			d: "M0 0h23v23H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f35325",
			d: "M1 1h10v10H1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#81bc06",
			d: "M12 1h10v10H12z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#05a6f0",
			d: "M1 12h10v10H1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffba08",
			d: "M12 12h10v10H12z"
		})
	]
});
export { SvgMicrosoft as ReactComponent };
